import { useCallback, useEffect, useState } from 'react';
import { post, api } from './lib/api';
import type { SessionState } from './lib/types';
import { Admin } from './components/Admin';
import { Device, Notice, Spinner } from './components/Device';
import { ClaimIdentity, Login } from './components/Login';
import { PlayerChat } from './components/Chat';

export default function App() {
  const [state, setState] = useState<SessionState | null>(null);
  const [fatal, setFatal] = useState('');
  const refresh = useCallback(async () => {
    try { setState(await api<SessionState>('/session')); setFatal(''); }
    catch (cause) { setFatal(cause instanceof Error ? cause.message : 'Nucleo irraggiungibile.'); }
  }, []);
  useEffect(() => { void refresh(); }, [refresh]);

  async function logout() {
    await post('/auth/logout');
    await refresh();
  }

  if (fatal) return <Device><Notice kind="error">{fatal}</Notice><button className="primary" onClick={() => void refresh()}>RIPROVA</button></Device>;
  if (!state) return <Device><Spinner label="HANDSHAKE" /></Device>;
  if (state.role === 'admin') return <Admin onLogout={logout} />;
  if (state.role === 'pending') return <ClaimIdentity players={state.availablePlayers} onRefresh={refresh} />;
  if (state.role === 'player' && state.campaign.status === 'running' && state.campaign.name && state.playerName) {
    return <PlayerChat name={state.campaign.name} playerName={state.playerName} initialBattery={state.campaign.battery} onLogout={logout} />;
  }
  return <Login state={state} onRefresh={refresh} />;
}
